import { ChangeDetectorRef, Component } from '@angular/core';
import { LMListBlockGridBaseDirective } from '@list/lm-list-blockgrid-base.directive';
import {
  LMBusyIndicatorService,
  LMContextService,
  LMErrorUtilService, LMFormatUtilService,
  LMLoggerService,
  LMUrlUtilService
} from '@app/services';
import { LMListEventService, LMListGridPagingService, LMListSpecUtilService, LMListUtilService } from '@list/services';
import { LMThemeService } from '@banner/lm-theme.service';

@Component({
  selector: 'lm-list-image',
  templateUrl: './lm-list-image.component.html',
  styleUrls: [ 'lm-list-image.component.scss' ]
})
export class LMListImageComponent extends LMListBlockGridBaseDirective {
  constructor(
    protected lmContextService: LMContextService,
    protected lmLoggerService: LMLoggerService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmThemeService: LMThemeService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmListEventService: LMListEventService,
    protected lmListGridPagingService: LMListGridPagingService,
    protected lmListSpecUtilService: LMListSpecUtilService,
    protected lmListUtilService: LMListUtilService,
    protected lmUrlUtilService: LMUrlUtilService
  ) {
    super(
      lmContextService,
      lmLoggerService,
      lmFormatUtilService,
      lmThemeService,
      lmBusyIndicatorService,
      changeDetectorRef,
      lmErrorUtilService,
      lmListEventService,
      lmListGridPagingService,
      lmListSpecUtilService,
      lmListUtilService,
      lmUrlUtilService
    );
  }
}
